import { render } from "./NotificationSingleResponseTextFeedbackEditPane.vue?vue&type=template&id=5b3a8b0e&ts=true"
import script from "./NotificationSingleResponseTextFeedbackEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationSingleResponseTextFeedbackEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__